import { AcademicCapIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

import { ADMISSIONS_PERMISSIONS } from "./admissions.permissions";

export const AdmissionsFeature: FeatureMetadata = {
  id: "admissions",
  moduleName: "academics",

  navigation: {
    label: "Admissions",
    path: "/admissions",
    icon: AcademicCapIcon,
    order: 6,
  },

  route: {
    path: "/admissions/*",
    element: lazy(() => import("./pages/AdmissionsPage")),
  },

  permissions: {
    view: ADMISSIONS_PERMISSIONS.view,
    create: ADMISSIONS_PERMISSIONS.create,
    edit: ADMISSIONS_PERMISSIONS.edit,
    delete: ADMISSIONS_PERMISSIONS.delete,
    onlineApplication: ADMISSIONS_PERMISSIONS.onlineApplication,
    approveApplication: ADMISSIONS_PERMISSIONS.approveApplication,
  },

  readiness: "live",
};
